import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { state } from 'lit/decorators.js';
import styles from './arc-bottombar.styles.js';
export default class ArcBottombar extends LitElement {
    constructor() {
        super(...arguments);
        this.tabs = 5;
    }
    _handleTabChange(e) {
        const isTab = (element) => element.tagName === 'ARC-ICON-BUTTON';
        const nodes = e.target.assignedElements({ flatten: true });
        const navTabs = nodes.filter(isTab);
        this.tabCount = navTabs.length;
        if (this.tabCount > this.tabs) {
            this.log(`Please limit your tab count to a maximum of ${this.tabs} tabs`);
        }
    }
    log(msg) {
        console.log(msg);
    }
    render() {
        return html `
      <nav id="main" aria-label="mobile navigation">
        <slot @slotchange=${this._handleTabChange}></slot>
      </nav>
    `;
    }
}
ArcBottombar.tag = 'arc-bottombar';
ArcBottombar.styles = styles;
__decorate([
    state()
], ArcBottombar.prototype, "tabs", void 0);
__decorate([
    state()
], ArcBottombar.prototype, "tabCount", void 0);
